import * as angular from 'angular';

import { ComponentDefinition, Miniature, Pattern } from '@models/index';

class WidgetSearchBarController implements angular.IComponentController {
    criteria: Pattern<Miniature>[];

    static $inject = [];

    $onInit() {
        this.criteria = [
            {
                label: 'Name',
                placeholder: 'Name',
                model: 'n',
                property: 'n',
                isMatch: (d, value) => {
                    return value.test(d.title);
                }
            },
            {
                label: 'Comments',
                placeholder: 'Comments',
                model: 'c',
                property: 'c',
                isMatch: (d, value) => d.highlights.filter(h => value.test(h)).length > 0
            }
        ];
    }
}

export const wtWidgetSearchBar: ComponentDefinition = {
    componentId: 'wtWidgetSearchBar',
    controller: WidgetSearchBarController,
    template: require('./widgetSearchBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        filteredMiniatures: '=',
        miniatures: '<'
    }
};
